module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/beer_69d8ca.jpg";